export default {
      id: "logo-aviation-usage",
      viewBox: "0 0 247 35",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-aviation",
      toString: function () {
        return this.url;
      }
    }